import React from 'react';
import PropTypes from 'prop-types';

const PanGstin = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.3343 14.0002C12.6771 14.0002 13.6676 13.0097 13.6676 11.6668C13.6676 10.324 12.6771 9.3335 11.3343 9.3335C9.99148 9.3335 9.00098 10.324 9.00098 11.6668C9.00098 13.0097 9.99031 14.0002 11.3343 14.0002Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M23.333 4.6665H4.66634C3.37951 4.6665 2.33301 5.64767 2.33301 6.854V21.1457C2.33301 22.352 3.37951 23.3332 4.66634 23.3332H23.333C24.6198 23.3332 25.6663 22.352 25.6663 21.1457V6.854C25.6663 5.64767 24.6198 4.6665 23.333 4.6665ZM23.333 20.9998L4.66634 20.987V6.99984L23.333 7.01267V20.9998Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M16.3333 10.5H21V12.8333H16.3333V10.5ZM17.5 15.1667H21V17.5H17.5V15.1667ZM15.6683 18.1253C15.6683 16.5223 13.713 14.875 11.3342 14.875C8.95533 14.875 7 16.5223 7 18.1253V18.6667H15.6683V18.1253Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

PanGstin.propTypes = {
  fill: PropTypes.string,
};

export default PanGstin;
